import styled from 'styled-components'

const MenuItemDetailsUi = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 10px;
`

export default MenuItemDetailsUi
